import React, { useState, useEffect, useContext } from "react";
//Material ui core
import { CssBaseline, useMediaQuery } from "@material-ui/core";
//Components
import Header from "./Header/Header";
import DrawerComp from "./DrawerComp";
//utils
import { useNavigationStyles } from "../../Util/CSS/NavigationStyles";
import Routes from "../../Util/Routes/Routes";
import { useTheme } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import AuthRoutes from "../../Util/Routes/AuthRoutes";
import { AuthContext } from "../../Context/Auth";
import Fallback from "../../Shared/Fallback";
import { ErrorBoundary } from "@sentry/react";
const Navigation = () => {
  const classes = useNavigationStyles();
  const { user } = useContext(AuthContext);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [open, setOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  useEffect(() => {
    let openVal = isMobile ? false : true;
    setOpen(openVal);
  }, [isMobile]);
  useEffect(() => {
    if (
      (window.navigator.onLine && errorMessage.trim() === "Failed to fetch") ||
      errorMessage.trim() === "Network Error"
    ) {
      autoReload();
      setErrorMessage("");
    }
  }, [errorMessage]);
  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };
  const onError = (error, errorInfo) => {
    setErrorMessage(error.message);
  };

  const autoReload = () => {
    setTimeout(() => {
      window.location.reload(false);
    }, 3000);
  };
  return (
    <div className={classes.root}>
      <CssBaseline />
      {user ? (
        <>
          {" "}
          <Header
            classes={classes}
            open={open}
            handleDrawerOpen={handleDrawerOpen}
            isMobile={isMobile}
          />
          <DrawerComp
            classes={classes}
            open={open}
            handleDrawerClose={handleDrawerClose}
            isMobile={isMobile}
          />
          <ErrorBoundary
            fallback={<Fallback error={errorMessage} />}
            onError={onError}
          >
            <main className={classes.content}>
              <div className={classes.toolbar} />
              <div className={classes.routeMargin}>
                <Routes />
              </div>
            </main>
          </ErrorBoundary>
        </>
      ) : (
        <main className={classes.login}>
          <AuthRoutes />
        </main>
      )}
    </div>
  );
};

export default withRouter(Navigation);
